import i18n from "@/i18n";

export const contentFields = [
    {
        key: "status",
        label: ""
    },
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true
    },
    {
        key: "type",
        label: i18n.t("common.type"),
        tdClass: "td-sm"
    },
    {
        key: "interactionBehavior",
        label: i18n.t("channels.interaction"),
        tdClass: "td-sm"
    },
    {
        key: "returnToFirstPostTime",
        label: i18n.t("channels.returnToFirstPostTime"),
        tdClass: "td-sm"
    },
    {
        key: "menuStyleId",
        label: i18n.t("menuStyles.menuStyle"),
        tdClass: "td-sm"
    },
    {
        key: "showFirstPost",
        label: i18n.t("channelGroups.showFirstPost"),
        tdClass: "td-sm"
    },
    {
        key: "eventName",
        label: i18n.t("stage.eventName"),
        tdClass: "td-sm"
    },
    {
        key: "default",
        label: i18n.t("posts.rss.default"),
        tdClass: "td-sm"
    },
    {
        key: "actions",
        label: ""
    }];
